import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { Button, Layout, Menu } from 'antd';
import { useEffect, useState } from 'react';
import Logo from './Logo';

import ThemeIcon from 'assets/svg/ThemeIcon';
import Icon from 'components/util-components/Icon';
import {
  NAV_TYPE_TOP,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_WIDTH,
} from 'constants/ThemeConstant';
import { useTheme } from 'stores/theme.store';
import utils from 'utils';
import NavSearch from './NavSearch';

const { Header } = Layout;

export const HeaderNav = ({ isMobile }) => {
  const {
    navCollapsed,
    toggleCollapsedNav,
    mobileNav,
    navType,
    headerNavColor,
    onMobileNavToggle,
    currentTheme,
    onSwitchTheme,
  } = useTheme();

  const [searchActive, setSearchActive] = useState(false);

  const onSearchClose = () => {
    setSearchActive(false);
  };

  const onToggle = () => {
    if (!isMobile) {
      toggleCollapsedNav(!navCollapsed);
    } else {
      onMobileNavToggle(!mobileNav);
    }
  };

  const toggleTheme = () => {
    onSwitchTheme(currentTheme === 'dark' ? 'light' : 'dark');
  };

  const isNavTop = navType === NAV_TYPE_TOP ? true : false;
  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(
        currentTheme === 'dark' ? '#00000' : '#ffffff'
      );
    }
    return utils.getColorContrast(headerNavColor);
  };
  const navMode = mode();
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return '0px';
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
    } else {
      return `${SIDE_NAV_WIDTH}px`;
    }
  };

  useEffect(() => {
    if (!isMobile) {
      onSearchClose();
    }
  });

  return (
    <Header
      className={`app-header ${navMode}`}
      style={{ backgroundColor: headerNavColor }}
    >
      <div className={`app-header-wrapper ${isNavTop ? 'layout-top-nav' : ''}`}>
        <Logo logoType={navMode} />
        <div
          className="nav"
          style={{ width: `calc(100% - ${getNavWidth()})` }}
        >
          <div className="nav-left">
            <ul className="ant-menu ant-menu-root ant-menu-horizontal">
              {isNavTop && !isMobile ? null : (
                <li
                  className="ant-menu-item ant-menu-item-only-child"
                  onClick={() => {
                    onToggle();
                  }}
                >
                  {navCollapsed || isMobile ? (
                    <MenuUnfoldOutlined className="nav-icon" />
                  ) : (
                    <MenuFoldOutlined className="nav-icon" />
                  )}
                </li>
              )}
            </ul>
          </div>
          <div className="nav-right">
            <div className="d-flex align-items-center">
              <Button
                type="ghost"
                shape="circle"
                onClick={toggleTheme}
                icon={<Icon type={ThemeIcon} />}
              />
            </div>
            <Menu mode="horizontal">
              <Menu.Item
                key="panel"
                onClick={() => (window.location.href = '/app/upload')}
              >
                <Button icon={<UploadOutlined />}>Criar conteúdo</Button>
              </Menu.Item>
            </Menu>
            {/* <NavPanel direction={direction} /> */}
          </div>
          <NavSearch
            active={searchActive}
            close={onSearchClose}
          />
        </div>
      </div>
    </Header>
  );
};

export default HeaderNav;
